import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Technology from './pages/Technology';
import AgenticAI from './pages/AgenticAI.tsx';
import Ecosystem from './pages/Ecosystem';
import NotFound from './pages/NotFound';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-slate-900 flex flex-col">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/technology" element={<Technology />} />
          <Route path="/services/agentic-ai" element={<AgenticAI />} />
          <Route path="/ecosystem" element={<Ecosystem />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;